export const OAUTH_ROUTE = `${process.env.REACT_APP_GOOGLE_OAUTH_ENDPOINT}/api/auth/facebook/login`;
